import ReportProblemIcon from '@mui/icons-material/ReportProblem';

const icons = {
  ReportProblemIcon
};

const Escalated = {
  id: 'escalation',
  type: 'group',
  children: [
    {
      id: 'escalation',
      title: 'Escalations',
      type: 'item',
      url: '/Escalations',
      icon: icons.ReportProblemIcon,
    }
  ]
};

export default Escalated;
